import {connect} from 'react-redux';
import BankAccountView from '../../components/views/mx/BankAccountView';
import {State} from '../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {FormFieldProps} from '../../../../common/types/components';
import {BankAccountFormDispatchProps, BankAccountFormStateProps, BankAccountFormType} from '../../types/mx/containers';
import {Catalog} from '../../../../common/types/common';
import * as BankAccountFormActions from '../../actions/mx/BankAccountFormActions';
import {
    BankAccountFile,
    BankAccountFileType,
    BankAccountState,
    BankAccountViewFieldErrorState
} from '../../types/mx/types';
import {GroupState as GeneralGroupState} from '../../types/mx/reducers';
import {uniqueArray} from '../../../../common/utils/ArrayUtils';
import {BankTarget} from '../../../loan/common/types/types';

const mapStateToProps = (state: State, ownProps): BankAccountFormStateProps => {
    const group: GeneralGroupState = state.group;
    const formType: BankAccountFormType =  !!ownProps.data && !!ownProps.data.formType ? ownProps.data.formType :
        BankAccountFormType.CREATE_FORM_FROM_GROUP;
    const target: string =  !!ownProps.data && !!ownProps.data.target ? ownProps.data.target :
        BankTarget.MOTORFY;
    const groupId: string = !!ownProps.data && !!ownProps.data.groupId ?
        ownProps.data.groupId : group.form.groupId;
    const bankAccount: BankAccountState = group.bankAccountForm;
    const bankAccountSelected: Catalog = bankAccount.bankSelected;
    const bankAccountFieldError: BankAccountViewFieldErrorState = group.ui.bankAccountFormView.fieldErrors;
    const banksCatalog: Catalog[] = group.catalogs.banks;
    const banksAccountList:Catalog[] =
        !!bankAccountSelected.value ? banksCatalog.concat(bankAccountSelected) : banksCatalog;
    return {
        groupId,
        formType,
        target,
        banksList: uniqueArray(banksAccountList),
        bankSelected: new FormFieldProps(bankAccountSelected, bankAccountFieldError.bankSelectedFieldError),
        accountNumber: new FormFieldProps(bankAccount.accountNumber, bankAccountFieldError.accountNumberFieldError),
        beneficiaryName: new FormFieldProps(bankAccount.beneficiaryName,
            bankAccountFieldError.beneficiaryNameFieldError),
        clabe: new FormFieldProps(bankAccount.clabe, bankAccountFieldError.clabeFieldError),
        dealerAccountStatusFile: new FormFieldProps(bankAccount.dealerAccountStatusFile,
            bankAccountFieldError.dealerAccountStatusFileFieldError),
        dealerOfficialIdentificationFile: new FormFieldProps(bankAccount.dealerOfficialIdentificationFile,
            bankAccountFieldError.dealerOfficialIdentificationFileFieldError),
        owner: bankAccount.owner,
        createAt: bankAccount.createAt
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): BankAccountFormDispatchProps => {
    return {
        onCancel: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onSave: (groupId: string, formType: BankAccountFormType, target: string) => {
            dispatch(BankAccountFormActions.GROUP_BANK_ACCOUNT_SAVE_ACTION.action(groupId, formType, target));
        },
        onChangeBank: (bankSelected: Catalog, error: string) => {
            dispatch(BankAccountFormActions.GROUP_CHANGE_BANK_ACTION.action(bankSelected, error));
        },
        onChangeAccountNumber: (accountNumber: string, error: string) => {
            dispatch(BankAccountFormActions.GROUP_CHANGE_BANK_ACCOUNT_NUMBER_ACTION.action(accountNumber, error));
        },
        onChangeBeneficiary: (beneficiary: string, error: string) => {
            dispatch(BankAccountFormActions.GROUP_CHANGE_BENEFICIARY_ACTION.action(beneficiary, error));
        },
        onChangeClabe: (clabe: string, error: string) => {
            dispatch(BankAccountFormActions.GROUP_CHANGE_CLABE_ACTION.action(clabe, error));
        },
        onDropFileAccount: (file: BankAccountFile, error: string) => {
            dispatch(BankAccountFormActions.GROUP_DROP_FILE_ACCOUNT_ACTION.action(file, error));
        },
        onDropFileIdentification: (file: BankAccountFile, error: string) => {
            dispatch(BankAccountFormActions.GROUP_DROP_FILE_IDENTIFICATION_ACTION.action(file, error));
        },
        onDeleteFile: (fileId: string, fileType: BankAccountFileType, error: string) => {
            dispatch(BankAccountFormActions.GROUP_DELETE_FILE_SUCCESS_ACTION.action(fileId, fileType, error));
        }
    };
};

const BankAccountContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(BankAccountView);

export default BankAccountContainer;
